import { GET_WORKFLOWS, ADD_WORKFLOW, GET_WORKFLOW_REQ } from '../types'

const INITIAL_STATE = {
  groups: [],
  fromworkflow: [],
  workflows: [],
  permissions: [],
  workflowMappings: [],
  addWorkflow: [],
}

const workflowReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_WORKFLOW_REQ:
      return {
        ...state,
      }
    case GET_WORKFLOWS:
      const { groupData: groups, workflows, permissions } = payload
      const permissionsMap = {}
      permissions.forEach((perm) => {
        const key = `${perm.groupId}-${perm.workflowId}`
        permissionsMap[key] = perm.permissions
      })

      const workflowMappings = permissions.length
        ? groups.map((group) => {
            const mapping = {
              groupName: group.name,
              groupId: group.id,
            }
            workflows.forEach((wf) => {
              const key = `${group.id}-${wf.id}`
              mapping[wf.id] = permissionsMap[key] || null
            })
            return mapping
          })
        : []

      return {
        ...state,
        groups,
        workflows,
        permissions,
        workflowMappings,
      }
    case ADD_WORKFLOW:
      return {
        ...state,
        addWorkflow: payload.data,
      }
    default:
      return state
  }
}

export default workflowReducer
